/*
 ------------------------------------------------------------------
|  Copyright (c) 2015 Izenda, Inc.                                 |
|  ALL RIGHTS RESERVED                                             |
|                                                                  |
|  The entire contents of this file is protected by U.S. and       |
|  International Copyright Laws. Unauthorized reproduction,        |
|  reverse-engineering, and distribution of all or any portion of  |
|  the code contained in this file is strictly prohibited and may  |
|  result in severe civil and criminal penalties and will be       |
|  prosecuted to the maximum extent possible under the law.        |
|                                                                  |
|  RESTRICTIONS                                                    |
|                                                                  |
|  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES           |
|  ARE CONFIDENTIAL AND PROPRIETARY TRADE                          |
|  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS              |
|  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET    |
|  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.                 |
|                                                                  |
|  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED      |
|  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE        |
|  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE       |
|  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT  |
|  AND PERMISSION FROM IZENDA INC.                                 |
|                                                                  |
|  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  |
|  ADDITIONAL RESTRICTIONS.                                        |
 ------------------------------------------------------------------
*/

/**
 * SourceTreeItem component
 */
!(function () {
  var React = require('react');
  var ReactDOM = require('react-dom');

  var m = require('mobx');
  var observer = require('mobx-react').observer;
  var connect = require('share/enhancers/Izenda.Connect');
  var classnames = require('classnames');

  var TextHighLight = require('share/components/controls/Izenda.TextHighLight');
  var Input = require('share/components/controls/Izenda.Input');
  var EventUtils = require('EventUtils');

  var SourceTreeItem = React.createClass({
    propTypes: {
      node: React.PropTypes.object.isRequired,
      filter: React.PropTypes.string,
      showCheckbox: React.PropTypes.bool,
      showIcon: React.PropTypes.bool
    },
    render: function () {
      var node = this.props.node;
      var filter = this.props.filter;
      var toggleCollapse = this.props.toggleCollapse;

      var containerClasses = classnames('checkbox', {
        'disabled-elm' : isEmptyGroup(node)
      });
      var showCheckboxClass = classnames('u_noMarginAll', {
        'hidden' : !this.props.showCheckbox
      });

      var childCount = node.childCount();
      var toggle = function () {
        toggleCollapse();
      }

      return (
        <div className={containerClasses} key={node.id}>
          <Input type="checkbox"
                 checked={node.dataSource.checked}
                 onChange={EventUtils.notifyChange(this.onCheck, EventUtils.CHECKBOX)}
                 className={showCheckboxClass} />
          <label
            className='tree-item'
            key={node.id}
            disabled={isEmptyGroup(node) ? 'disabled' : null} >

            <TextHighLight highlight={filter} text={node.name} />
          </label>

          {!isEmptyGroup(node) ?
            <i className='icon-toggle-triangle' onClick={toggle} /> : null}
        </div>
      );

      function isEmptyGroup (node) {
        return node.isTypeGroup() && childCount === 0;
      }
    },

    /**
     * handle onCheck event
     * @param  {Boolean} checked
     */
    onCheck: m.action(function(checked) {
      this.props.node.setChecked(checked);
    })
  });

  module.exports = connect()(SourceTreeItem);
}());



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/AdvancedSetting/SecurityRules/Izenda.SourceTreeItem.jsx